import { useQuery } from "@tanstack/react-query";
import API from "../api";

function useScene(sceneId?: string) {
  const { isPending, error, data, refetch } = useQuery({
    queryKey: ["scenes", sceneId],
    queryFn: () => {
      if (!sceneId) throw Error("Not found.");
      return API.getScene(sceneId);
    },
    refetchInterval: 5 * 60 * 1000, // Refetch data every five minutes
    retry: false
  });

  return {
    isPending,
    error,
    scene: data,
    refetch
  };
}

export default useScene;
